import { render, staticRenderFns } from "./RollNumberUpdate.vue?vue&type=template&id=4e11372e"
import script from "./RollNumberUpdate.vue?vue&type=script&lang=js"
export * from "./RollNumberUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports